import React, { FunctionComponent, SVGProps } from "react";
import styles from "./icon-info-block.module.css";

export default function IconInfoBlock({
    Icon,
    label,
    replacedValue,
    value,
    bookingFlow,
}: {
    Icon: FunctionComponent<SVGProps<SVGSVGElement>>;
    label?: string;
    replacedValue?: string;
    value: string;
    /** Icon aligns with the first text row only (booking-flow confirmation). */
    bookingFlow?: boolean;
}): React.ReactElement {
    if (bookingFlow) {
        return (
            <div className={styles.info__containerBookingFlow}>
                <Icon className={styles.info__iconBookingFlow} aria-hidden />
                {!!label && (
                    <div className={styles.info__labelBookingFlow}>{label}</div>
                )}
                {!!replacedValue && (
                    <div
                        className={`${styles.info__valueBookingFlow} ${styles["info__value--replaced"]}`}
                    >
                        {replacedValue}
                    </div>
                )}
                <div
                    className={
                        label
                            ? styles.info__valueBookingFlow
                            : styles.info__valueBookingFlowPrimary
                    }
                >
                    {value}
                </div>
            </div>
        );
    }

    return (
        <div className={styles.info__container}>
            <Icon className={styles.info__icon} />
            <div className={styles.info__block}>
                {!!label && <div className={styles.info__label}>{label}</div>}
                {!!replacedValue && (
                    <div
                        className={`${styles.info__value} ${styles["info__value--replaced"]}`}
                    >
                        {replacedValue}
                    </div>
                )}
                <div className={styles.info__value}>{value}</div>
            </div>
        </div>
    );
}
